export enum NotificationsEnum {
    UNKNOWN = 0,
    ERROR = 1,
    SUCCESS = 2,
    INFO = 3,
    WARNING = 4
}
